import * as React from "react";
import { FormattedMessage } from "react-intl";

export const requiredrule = {
    required: true,
    message: <FormattedMessage id="form.isrequired" />
};
